<template>
  <div class="top-bar-container">
    <v-app-bar flat dense class="top-bar" height="48">
      <v-spacer></v-spacer>

      <div class="user-info">
        <v-btn icon small class="action-btn" title="התנתק" @click="logout()">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
        <v-icon color="#0d2c6d" class="user-icon">mdi-account-circle</v-icon>
        <span class="user-name">
          <b>מחובר: </b>{{ userName }} {{ business_name }}
        </span>
        <v-btn v-if="role === 'admin'" small text class="line-number-btn" @click="showLogs()">
          <span class="line-number">{{ lineNumber }}</span>
          <v-icon small right color="#0d2c6d">mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn v-else disabled small text class="line-number-btn" >
          <span class="line-number">{{ lineNumber }}</span>
          <v-icon small right color="#0d2c6d">mdi-chevron-right</v-icon>
        </v-btn>
      </div>

    </v-app-bar>
  </div>
</template>

<script>
import Auth from '@/services/auth.service.js'
import { mapState, mapMutations } from 'vuex';

export default {
  data: () => ({
  }),
  methods: {
    showLogs() {
      if (this.role === "admin") {
        this.$router.push({ name: 'logs' });
      }
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.replace({ name: 'login' });
    },
  },
  computed: {
    ...mapState(['lineNumber', "userName", "business_name", "role"]), // Get Vuex state
  },
  created() {
  },
}
</script>

<style scoped>
.top-bar-container {
  width: 100%;
}

.top-bar {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.user-info {
  display: flex;
  align-items: center;
  direction: ltr;
  padding: 0 8px;
}

.user-icon {
  margin-right: 8px;
}

.user-name {
  font-size: 14px;
  color: #0d2c6d;
  margin-right: 12px;
}

.line-number {
  font-size: 14px;
  font-weight: 600;
  color: #0d2c6d;
  text-decoration: none;
}

.line-number-btn {
  margin-left: 8px;
  padding: 0 8px;
  height: 28px;
  border-radius: 14px;
  background-color: rgba(13, 44, 109, 0.1);
  transition: all 0.2s ease;
}

.line-number-btn:hover {
  background-color: rgba(13, 44, 109, 0.2);
  transform: translateY(-1px);
}

.actions {
  display: flex;
  align-items: center;
}

.action-btn {
  margin-left: 8px;
  color: #0d2c6d;
  transition: all 0.2s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .user-name {
    font-size: 12px;
  }

  .line-number {
    font-size: 12px;
  }
}
</style>